export function diff_in_days(dateString) {
  const date = new Date(dateString);
  const today = new Date();

  const duration = date.getTime() - today.getTime();
  return duration / (1000 * 3600 * 24);
}
